module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._t("default", null, {
    "showItem": _vm.showItem,
    "activeItem": _vm.activeItem,
    "windowWidth": _vm.windowWidth,
    "showContainer": _vm.showContainer,
    "setActiveItem": _vm.setActiveItem
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1001f53f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseHero.vue
// module id = 298
// module chunks = 1